import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "icon-button",
  templateUrl: "./icon-button.component.html",
  styleUrls: ["./icon-button.component.scss"],
})
export class IconButtonComponent implements OnInit {
  className: string;
  @Input() variant: string;
  @Input() disabled: boolean = false;
  @Input() label: string;
  @Input() icon: string;
  @Input() iconType: string;
  @Output() onClick = new EventEmitter<MouseEvent>();

  onClickButton(event: MouseEvent) {
    this.onClick.emit(event);
  }
  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    this.label = "";
    this.icon = "star";
    this.variant = "default";
    this.className = "btn-default";
    this.iconType = "icon";
  }

  ngOnInit(): void {
    this.matIconRegistry.addSvgIcon(
      `help`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        `/assets/images/help.svg`
      )
    );
    this.className = `btn-${this.variant}`;
  }
}
